import {
    GET_CATERING_TASKS_LIST,
    GET_CATERING_TASKS_LIST_FAILURE,
    GET_CATERING_TASKS_LIST_SUCCESS,
} from '../../../modules/constants';

const initialState = {
    isLoading: false,
    cateringTasksList: [],
    cateringTasksListCount: 0,
    cateringTaskPageSize: 10,
};

const cateringTaskReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CATERING_TASKS_LIST:
            return {
                ...state,
                isLoading: true,
            };
        case GET_CATERING_TASKS_LIST_SUCCESS:
            const { data } = action.payload;
            return {
                ...state,
                isLoading: false,
                cateringTasksList: data.results || [],
                cateringTasksListCount: data.count || 0,
                cateringTaskPageSize: data.page_size || 10,
            };
        case GET_CATERING_TASKS_LIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                cateringTasksList: [],
                cateringTasksListCount: 0,
            };
        default:
            return state;
    }
};

export default cateringTaskReportReducer;
